/** Every word the page tour says (SA-1315). */

/** The tour's name, from its page guide's title: "Inbox and triage tour". */
export const tourName = (title: string) => `${title} tour`

/** "2 of 5" (`step` is zero-based). */
export const stepCount = (step: number, total: number) => `${step + 1} of ${total}`

/** The polite announcement as a step lands. */
export const stepAnnouncement = (step: number, total: number, text: string) =>
  `Step ${step + 1} of ${total}: ${text}`

export const MISSING_DEFAULT = "This part isn't on the page right now."

/** Under a do step's text: the person may press the control itself (SA-1316). */
export const orPress = (name: string) => `Or press ${name}.`
export const WHAT_YOULL_SEE = "What you'll see"

export const BACK = 'Back'
export const NEXT = 'Next'
export const DONE = 'Done'
export const SKIP = 'Skip'
export const END_TOUR = 'End tour'
export const EXIT = 'Exit'
export const CLOSE_TOUR = 'Close tour'

/** The Ask tab's opening chip and the user menu's row. */
export const SHOW_ME_AROUND = 'Show me around'
export const TOUR_THIS_PAGE = 'Tour this page'
